// extracted by mini-css-extract-plugin
module.exports = {"banner":"index_banner__2EJvW","ruleToggle":"index_ruleToggle__14gG6","pintuanList":"index_pintuanList__3aNr_"};